export class themeColorConfig {
   navBarColor = "white";
   navBarTextColor = "white"

}

export class navBarColor {
   bg= '#351113';
   text= '#FFCF03';
   white= '#FFFFF0';
   hover= '#35111380';
}

export class orderOnlinePage {
   text = '#FFCF03';
   main = '#351113';
   button = '#8b5f2a'
}

export class HomePageColor{
   // gradient = 'linear-gradient(90deg, #891313, #ECD73C, #891313)'
   // gradient = "red"
   gradient = "#351113";
   text= '#FFCF03';
}